import { Component } from '@angular/core';

@Component({
  selector: 'app-pillar-2',
  imports: [],
  templateUrl: './pillar-2.component.html',
  styleUrl: './pillar-2.component.scss'
})
export class Pillar2Component {

}
